<template>
  <b-modal ref="modal"
           hide-footer
           title="Order Options">
    <template>
      <div class="mb-3">
        Patient Login: {{ email }}
      </div>
      <template v-if="status !== reportStatus.Completed">
        Would you like to send reminder to the Patient to complete the next step?
        <div class="section-footer">
          <b-btn class="mr-3" variant="success" @click="showEditModal" :disabled="emailConfirmed">Edit Patient Login</b-btn>
          <b-btn variant="success" @click="notify">Send Reminder</b-btn>
        </div>
      </template>
    </template>
    <template v-if="canEditSurvey">
      <hr class="negative-margin mb-3" />
      Would you like to revise the report's input information?'
      <div class="section-footer">
        <b-btn variant="success" :disabled="isBeforeSixtyDays" :title="questionnaireHoverText" @click="editSurvey">Questionnaire</b-btn>
      </div>
    </template>
    <template v-if="status !== reportStatus.Completed">
      <hr class="negative-margin mb-3" />
      Cancel order? Note: cancelled orders cannot be undone.
      <v-form-group>
        <b-checkbox v-model="sendEmailOnCancel">
          Send an Email to patient
        </b-checkbox>
      </v-form-group>
      <div class="section-footer">
        <b-btn class="mr-3" variant="outline-secondary" @click="close">Nevermind</b-btn>
        <b-btn variant="success" @click="cancel">Cancel Order</b-btn>
      </div>
    </template>
    <b-modal ref="editModal"
             cancel-variant="outline-secondary"
             ok-variant="success"
             @ok="saveEmail"
             title="Edit Patient Email">
      <b-form-input v-model="email" />
    </b-modal>
  </b-modal>
</template>

<script>
  import reportService from "services/report-service";
  import ReportStatus from "enums/report-status";
  import moment from "moment";
  import { mapActions } from 'vuex';

  export default {
    data() {
      return {
        sendEmailOnCancel: true,
        reportId: null,
        status: null,
        email: null,
        emailConfirmed: false,
        reportStatus: ReportStatus,
        isBeforeSixtyDays: false
      }
    },

    computed: {
      canEditSurvey() {
        return (this.status === ReportStatus.WaitingResults || this.status === ReportStatus.Completed);
      },

      questionnaireHoverText() {
        if (!this.isBeforeSixtyDays) {
          return;
        }

        return "An Order can only be revised for 60 " +
          "days after the initial delivery since " +
          "biological conditions will have " +
          "noticeable changes after this time " +
          "period and the Assessment will no " +
          "longer be accurate.";
      },
    },

    methods: {
      ...mapActions('user', ['loginAsUser']),

      async show(data) {
        this.reportId = data.id;
        this.status = data.status;

        const sixtyDaysFromNow = moment().subtract(60, 'days');
        this.isBeforeSixtyDays = moment(data.completionDate).isBefore(sixtyDaysFromNow, 'day');

        const patientEmail = await reportService.getPatientEmail(this.reportId);

        this.email = patientEmail.email;
        this.emailConfirmed = patientEmail.emailConfirmed;

        this.$refs.modal.show();
      },

      close() {
        this.$refs.modal.hide();
      },

      async cancel() {
        if (!this.reportId) {
          return;
        }

        await reportService.cancel(this.reportId, this.sendEmailOnCancel);
        this.$root.successToast("Report cancelled!");
        this.$emit("cancel");
        this.close();
      },

      async notify() {
        await reportService.notify(this.reportId);
        this.$root.successToast("Notification sent!");
        this.close();
      },

      showEditModal() {
        this.$refs.editModal.show();
      },

      editSurvey() {
        if (this.isBeforeSixtyDays) {
          return;
        }

        this.loginAsUser({
          user: { email: this.email },
          reportToEditId: this.reportId
        });
      },

      async saveEmail() {
        await reportService.updatePatientEmail(this.reportId, this.email)
        this.$root.successToast("Patient email updated!");
      }
    }
  }
</script>

<style lang="scss">
  .negative-margin {
    margin: 0 -1.5rem;
  }

  .section-footer {
    padding: 1rem 0;
    display: flex;
    justify-content: flex-end;
    margin: 0 0 1rem 0;

    &:not(:first-child) {
      padding: 1rem 0 0 0;
    }
  }
</style>